import { Box, Flex, HStack } from '@chakra-ui/react';
import ProductFieldColumn from 'components/common/ProductFieldColumn/ProductFieldColumn';
import ProductFieldColumnTitle from 'components/common/ProductFieldColumnTitle';
import { IConditions, IObject, IType, IValueCondition } from '../../../../server/types';

const ParameterField = ({
  data,
  fieldType,
  displayName,
}: {
  data: string | number | boolean | IType | IConditions | IObject | IValueCondition | undefined;
  fieldType: string;
  displayName: string;
}) => {
  const renderValue = () => {
    const value = data?.toString();

    if (value === '') {
      return (
        <Box color="base2Colour.500" fontStyle="italic">
          none
        </Box>
      );
    }

    return <Flex>{value}</Flex>;
  };

  const renderRows = (indexValues: string | string[]) =>
    Object.values(data as Record<string, Record<string, string>>).map((rowData: Record<string, string>) => (
      <Flex flex={1} key={rowData[indexValues[0]].toString()}>
        <ProductFieldColumn>{rowData[indexValues[0]].toString()}</ProductFieldColumn>
        <ProductFieldColumn>{rowData[indexValues[1]].toString()}</ProductFieldColumn>
      </Flex>
    ));

  const renderMultipleValues = (columnTitles: string | string[], indexValues: string | string[]) => (
    <Box
      sx={{
        borderTopWidth: 2,
        borderTopStyle: 'solid',
        borderTopColor: 'base2Colour.400',
        p: 0.5,
        m: 2.5,
      }}
    >
      <Flex flex={1} justifyContent="flex-start" pb={0.5}>
        <ProductFieldColumnTitle>{columnTitles[0]}</ProductFieldColumnTitle>
        <ProductFieldColumnTitle>{columnTitles[1]}</ProductFieldColumnTitle>
      </Flex>
      {renderRows(indexValues)}
    </Box>
  );

  let columnTitles: string | string[] = '';
  let indexValues: string | string[] = '';
  if (fieldType === 'values') {
    columnTitles = ['Display Name', 'Value'];
    indexValues = ['displayName', 'value'];
  }
  if (fieldType === 'expressions') {
    columnTitles = ['If', 'Expression', 'Operator'];
    indexValues = ['if', 'expression', 'operator'];
  }
  if (columnTitles === '') {
    return (
      <HStack
        sx={{
          flex: 1,
          justifyContent: 'space-between',
          bgColor: 'base2Colour.500',
          m: 0.5,
          p: 2.5,
          alignItems: 'center',
          fontSize: 'sm',
          color: 'base2FontColour.500',
        }}
      >
        <Flex flex={1} textTransform="uppercase" alignItems="flex-start">
          {displayName}
        </Flex>
        {renderValue()}
      </HStack>
    );
  }

  return (
    <Flex
      sx={{
        flex: 1,
        flexDir: 'column',
        bgColor: 'base2Colour.500',
        m: 0.5,
        p: 2.5,
        fontSize: 'sm',
        color: 'base2FontColour.500',
      }}
    >
      <Flex flex={1} textTransform="uppercase">
        {displayName}
      </Flex>
      {renderMultipleValues(columnTitles, indexValues)}
    </Flex>
  );
};

export default ParameterField;
